import {useMemo, useState} from "react";
import {
  Paper, Box, Typography, Button, Stepper, Step, StepLabel, StepContent,
  typographyClasses, Stack, Card, useTheme
} from '@mui/material'
import AppLoadingButton from '@/components/mui/LoadingButton';
import Timeline from '@mui/lab/Timeline';
import TimelineItem, {timelineItemClasses} from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent, {timelineContentClasses} from '@mui/lab/TimelineContent';

import {cardActivate} from '@/services'
import {useBoolean, useRequest} from "ahooks";
import {styled} from "@mui/system";
import classes from "./index.module.css";
import RpIcon from "@/components/RpIcon";
import AppModal from "@/components/AppModal.tsx";
import PinInput from '@/pages/card/components/PinInput/PinInput'
import {CARD_TYPE} from "@/constant/Constant.ts";
import {useTranslation} from "react-i18next";
import SimpleHeader from "@/pages/components/Headers/SimpleHeader.tsx";

const StyledTimelineItem = styled(TimelineItem)(({theme}) => {
  return {
    minHeight: theme.typography.pxToRem(56)
  }
})

const StyledTimelineConnector = styled(TimelineConnector)(({theme}) => {
  return {
    backgroundColor: theme.palette.text.primary,
    width: '1px'
  }
})

const StyledTimelineContent = styled(TimelineContent)(({theme}) => {
  return {
    padding: 0,
    paddingLeft: 6,
    lineHeight: 1,
    fontSize: theme.typography.pxToRem(14),
    paddingTop: '8px'
  }
})

const StyledTimelineSeparator = styled(TimelineSeparator)(({theme}) => {
  return {
    paddingTop: 2,
  }
})

const PhysicalCardOperate = (props) => {
  const {card, onActivated} = props
  const [code, setCode] = useState('')
  const theme = useTheme()
  const {t} = useTranslation()
  const [codeModalShow, codeModalShowOperate] = useBoolean(false);

  const cardActivateReq = useRequest(async () => {
    const res = await cardActivate(card.cardId, code)
    return res
  }, {manual: true})

  const doActivate = () => {
    cardActivateReq.runAsync().then(() => {
      codeModalShowOperate.setFalse()
      onActivated && onActivated({
        ...card,
        physicalCardStatus: 'CARD_ACTIVATED'
      })
    }).finally(() => {
      codeModalShowOperate.setFalse()
    })
  }

  const currentStep = useMemo(() => {
    if (!card || card.cardType != CARD_TYPE.CARD_TYPE_PHYSICAL) {
      return -1
    }
    if (card && card?.physicalCardStatus === 'CARD_NOT_ORDERED') {
      return 0
    }
    else if (card?.deliverNo != '') {
      return 1
    }
    return 2
  }, [card])
  const canCardActivate =  useMemo(() => {
    if (!card) {
      return 0
    }
    return card?.physicalCardStatus !== 'CARD_NOT_ORDERED' &&
      card?.isActive == 1
  }, [card])
  return (<>
    <Box className={classes.root} sx={(theme) => {
      return {
        backgroundColor: theme.palette.background.four,
      }
    }}>
      <Timeline
        sx={({theme}) => {
          return {
            padding: 0,
            margin: 0,
            [`& .${timelineItemClasses.root}:before`]: {
              flex: 0,
              padding: 0,
            },
          }
        }}
      >
        <StyledTimelineItem>
          <StyledTimelineSeparator>
            <RpIcon icon="card" size={22} />
            <StyledTimelineConnector/>
          </StyledTimelineSeparator>
          <StyledTimelineContent
            sx={theme => {
              let _stl = {}
              if (currentStep <= 0) {
                _stl = {
                  color: theme.palette.text.primary,
                  fontFamily: 'Urbanist-bold !important',
                }
              } else {
                _stl = {
                  // color: theme.palette.text.tertiary,
                }
              }
              return _stl
            }}
          >
            {t('card_in_production')}
          </StyledTimelineContent>
        </StyledTimelineItem>
        <StyledTimelineItem>
          <StyledTimelineSeparator>
            <RpIcon icon={'send'} size={24} />
            <StyledTimelineConnector />
          </StyledTimelineSeparator>
          <StyledTimelineContent
            sx={theme => {
              let _stl = {}
              if (currentStep === 1) {
                _stl = {
                  color: theme.palette.text.primary,
                  fontFamily: 'Urbanist-bold !important',
                }
              } else if (currentStep < 1) {
                _stl = {
                  color: theme.palette.text.tertiary,
                }
              }
              return _stl
            }}
          >
            {t('redotpay_card_sent')}
          </StyledTimelineContent>
        </StyledTimelineItem>
        <StyledTimelineItem sx={{minHeight: 'auto'}}>
          <StyledTimelineSeparator>
            <RpIcon icon="check-circle-thin" size={24} />
            <img src="/images/card/card_not_ordered.svg"/>
            {/*<StyledTimelineConnector/>*/}
          </StyledTimelineSeparator>
          <StyledTimelineContent
          sx={theme => {
            let _stl = {}
            if (currentStep === 2) {
              _stl = {
                color: theme.palette.text.primary,
                fontFamily: 'Urbanist-bold !important',
              }
            } else {
              _stl = {
                color: theme.palette.text.tertiary,
              }
            }
            return _stl
          }}
          >
            {t('redotpay_card_activated')}
          </StyledTimelineContent>
        </StyledTimelineItem>
      </Timeline>
      <AppLoadingButton
        size="small"
        // disabled={!canCardActivate}
        onClick={() => {
          codeModalShowOperate.setTrue()
          // doActivate()
        }} loading={cardActivateReq.loading}
        variant="contained" className={classes.activateButton}>{t('activate_card')}</AppLoadingButton>
    </Box>
    <AppModal
    open={codeModalShow} onClose={codeModalShowOperate.setFalse}
    >
      <SimpleHeader
        title={t('activate_card')}
      closeButton={
        <RpIcon icon="close" clickable
        onClick={() => {
          codeModalShowOperate.setFalse()
        }}
        />
      }
      />
      <Stack
        sx={{padding: '16px'}}
        alignItems="center" justifyContent="center">
        <PinInput
          separator={null}
          length={6}
          value={code}
          onChange={setCode}
        />
        <AppLoadingButton
          fullWidth
          onClick={() => {
            doActivate()
          }} loading={cardActivateReq.loading}
          variant="contained" className={classes.activateButton}>{t('activate_card')}</AppLoadingButton>
      </Stack>
    </AppModal>
  </>)
}

export default PhysicalCardOperate